import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  center: {
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
  },
  reproveButton: {
    borderColor: '#dc3f53',
    background: '#dc3f53',
    margin: '1rem',
    color: '#ffff',
    '&:hover': {
      borderColor: '#dc3f53',
      background: '#dc3f53',
      color: '#ffff',
      transition: 'background-color 0.2s, box-shadow 0.3s',
    },
  },
  approveButton: { margin: '1rem' },
  approveContent: { marginTop: '1rem', marginBottom: '1rem' },
}));
